import { useEffect, useRef, useState } from 'react';

/**
 * Более простой хук, в отличие от useCountdown
 * Просто принимает значения в секундах и запускает таймер
 * Также очищает его при завершении
 * @param time
 * @returns secondsLeft
 */
const useSimpleCountdown = (time: number): number => {
  const [secondsLeft, setSecondsLeft] = useState(time);
  const intervalIdRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    intervalIdRef.current = setInterval(() => {
      setSecondsLeft((previousSeconds) => {
        if (previousSeconds <= 1) {
          if (intervalIdRef.current) clearInterval(intervalIdRef.current);
          return 0;
        }

        return previousSeconds - 1;
      });
    }, 1000);
    return () => {
      if (intervalIdRef.current) clearInterval(intervalIdRef.current);
    };
  }, []);
  return secondsLeft;
};

export default useSimpleCountdown;
